export default __webpack_public_path__ + "static/media/Hamburgesa.25ee2cb8.gif";